<template>
  <div id="paypal-button-container">
    <div id="loadingButtonCreditCard" v-if="!ready">
      <i class="fa fa-spin fa-spinner"></i>
      Preparando...
    </div>
  </div>
</template>
<style lang="css">
  #loadingButtonCreditCard {
    display: flex;
    justify-content: center;
  }
  #loadingButtonCreditCard i {
    margin-right: .4rem
  }
  @media screen and (max-width: 400px) {
    #paypal-button-container {
      width: 100%;
    }
  }
  @media screen and (min-width: 400px) {
    #paypal-button-container {
      width: 250px;
      display: inline-block;
    }
  }
</style>
<script>
import { mapGetters } from 'vuex'

export default {
  name: 'CreditCard',
  props: [
    'price',
    'name',
    'code',
    'notify',
    'sandbox'
  ],
  data () {
    return {
      ready: false
    }
  },
  computed: {
    ...mapGetters([
      'user'
    ]),
    typeOp () {
      return (this.sandbox) ? 'sandbox' : 'production'
    }
  },
  methods: {
    paypalLoad () {
      const vm = this

      console.log('Paypal Load!!!')
      vm.$set(vm, 'ready', true)
      paypal.Button.render({ // eslint-disable-line
        env: vm.typeOp, // sandbox | production
        style: {
          label: 'buynow',  // checkout | credit | pay | buynow | generic
          size: 'responsive', // small | medium | large | responsive
          shape: 'rect',   // pill | rect
          color: 'blue'   // gold | blue | silver | black
        },
        client: {
          sandbox: 'Aag5BjAYsQKW0F-G_KUu8mRNip9zRzBxdmSnEo2zTYuvOkKXZJphLIIc0MC9Hg1b7Pw7fFYsO7DL58cP',
          production: '<insert production client id>'
        },
        payment: (data, actions) => {
          return actions.payment.create({
            payment: {
              transactions: [
                {
                  amount: {
                    total: vm.price,
                    currency: 'USD'
                  }
                }
              ]
            }
          })
        },
        onAuthorize: (data, actions) => {
          console.log(data)
          return actions.payment.execute().then(() => {
            window.alert(`Payment Complete! ${vm.user} ${vm.name}-${vm.code}`)

            // Enviar por correo y correr algunas tareas de ejecución
          })
        }
      }, '#paypal-button-container')
    }
  },
  mounted () {
    const vm = this
    vm.$nextTick(() => {
      const paypalScript = document.createElement('script')
      paypalScript.setAttribute('src', 'https://www.paypalobjects.com/api/checkout.js')
      document.head.appendChild(paypalScript)
      paypalScript.onload = vm.paypalLoad
    })
  }
}
</script>



// WEBPACK FOOTER //
// paypal-credit-card.vue?033c25db